import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';

//import { SitemarkIcon } from './CustomIcons';

const items = [
  {
    icon: <SettingsSuggestRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Adaptable performance',
    description:
      'Our product effortlessly adjusts to your needs, boosting efficiency and simplifying your tasks.',
  },
  {
    icon: <ConstructionRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Built to last',
    description:
      'Experience unmatched durability that goes above and beyond with lasting investment.',
  },
  {
    icon: <ThumbUpAltRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Great user experience',
    description:
      'Integrate our product into your routine with an intuitive and easy-to-use interface.',
  },
  {
    icon: <AutoFixHighRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Innovative functionality',
    description:
      'Stay ahead with features that set new standards, addressing your evolving needs better than the rest.',
  },
];

export default function Content() {
  return (
    <Stack
      sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4}}
    >
       <Stack spacing={2} sx={{ p:8}}>
            <Typography  sx={{
                display: 'flex',
                alignSelf: 'left',
                fontWeight:"bolder"}}>
                OFRECEMOS
            </Typography>
            <Typography
                variant="h1"
                sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: 'center',
                fontSize: 'clamp(3rem, 10vw, 3.5rem)',
                fontWeight:"bolder"
                }}
            >
                Las marcas
                <Typography
                component="span"
                variant="h1"
                sx={(theme) => ({
                    
                    fontSize: 'inherit',
                    color: 'primary.main',
                    ...theme.applyStyles('dark', {
                    color: 'primary.light',
                    }),
                })}
                >
                &nbsp;que más&nbsp;

                
                </Typography>
            </Typography>
            <Typography
                variant="h2"
                sx={{
                fontSize: 'clamp(3rem, 10vw, 3.5rem)',
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: 'right',
                fontWeight:"bolder"
                }}
            >
                &nbsp; &nbsp;se venden&nbsp;
                <Typography
                component="span"
                variant="h1"
                sx={(theme) => ({
                    fontSize: 'inherit',
                    color: 'primary.secondary',
                    ...theme.applyStyles('dark', {
                    color: 'secondary.secondary',
                    }),
                })}
                >
                en tu tiendita
                
                </Typography>
            </Typography>
        </Stack>
      {/*{items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}*/}
    </Stack>
  );
}